import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Hidden from '@material-ui/core/Hidden';
import { useSelector, useDispatch } from 'react-redux';
import { HANDLE_DRAWER_TOGGLE } from '../../redux/types';

import Navigator from '../navigator/Navigator';
import { getUserCountry, getAllCountries } from '../../redux/actions/dataActions';


import styles from '../../utils/mainStyle';

import { drawerWidth } from '../../utils/mainStyle';

function CommonNavigator(props) {
  const { classes, component: Component, ...rest } = props;
  

  return (

      <React.Fragment>
        <CssBaseline />
        <nav className={classes.drawer}>
         <Component {...rest}/>
        </nav>      

      </React.Fragment>
    
  );
}

CommonNavigator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CommonNavigator);